<template>
  <header :class="{menuOpen: menuOpen, menuAnimate: menuAnimate, scrolled: scrolled}">
    <div class="headerBg"></div>
    <div class="container">
      <router-link to="/" class="logoLink">
        <div class="logo"></div>
        <div class="logo white"></div>
      </router-link>
      <div class="menu">
        <div class="closeMenu" v-on:click="toggleMenu"></div>
        <router-link class="menuItem menuHome" to="/">Home</router-link>
        <div class="menuItem hasSubmenu" :class="{active: menuActive === 'bumi-kini'}"
          v-on:click="showSubmenu = !showSubmenu">Bumi Kini
          <div class="submenuOverlay" v-if="showSubmenu"
            v-on:click.stop="showSubmenu = false"></div>
          <div class="submenu" v-on:click.stop="doNothing" v-if="showSubmenu">
            <router-link to="/bumi-kini/bumi-dan-krisis-iklim">Bumi dan Krisis Iklim</router-link>
            <router-link to="/bumi-kini/faktor-faktor">Faktor-faktor</router-link>
            <router-link to="/bumi-kini/dampak-yang-mengancam">Dampak yang mengancam</router-link>
            <router-link to="/bumi-kini/upaya-demi-upaya">Upaya demi Upaya</router-link>
          </div>
        </div>
        <div class="menuItem hasSubmenu" :class="{active: menuActive === 'bicara-bumi'}"
          v-on:click="showSubmenu2 = !showSubmenu2">Bicara Bumi
          <div class="submenuOverlay" v-if="showSubmenu2"
            v-on:click.stop="showSubmenu2 = false"></div>
          <div class="submenu" v-on:click.stop="doNothing" v-if="showSubmenu2">
            <router-link to="/bicara-bumi/kabar-terkini">Kabar Terkini</router-link>
            <router-link to="/bicara-bumi/seputar-iklim">Seputar Iklim</router-link>
            <router-link to="/bicara-bumi/pesan-dan-kreasi">Pesan dan Kreasi</router-link>
          </div>
        </div>

        <!--
        <router-link to="/bumi-kini"
          :class="{active: menuActive === 'bumi-kini'}">Bumi Kini</router-link>
        <router-link class="menuItem" to="/bicara-bumi"
          :class="{active: menuActive === 'bicara-bumi'}">Bicara Bumi</router-link>
        -->
        <router-link class="menuItem"
          :class="{active: menuActive === 'sumber-dan-materi'}"
          to="/sumber-dan-materi">Sumber dan Materi</router-link>
        <!-- <router-link to="#">Jejaring</router-link> -->
        <router-link class="menuItem" to="/beraksi"
          :class="{active: menuActive === 'beraksi'}">Beraksi</router-link>
        <!-- <router-link to="/#">Curhat Iklim</router-link> -->
        <div class="loginBtn" v-on:click="$emit('login')" v-if="!$session.get('jwt')">Masuk</div>
        <div class="userPict" v-else v-on:click.stop="doNothing">
          <div :class="{headerPict: 1, hasPhoto: $session.get('avatar')}"
            :style="{'background-image': `url(${$session.get('avatar')})`}"
            v-on:click.stop="showMenu = true">
            <span>{{$session.get('name').substr(0,2)}}</span>
          </div>
          <div class="userMenuOverlay" v-if="showMenu" v-on:click.stop="showMenu = false"></div>
          <div class="userMenu" v-if="showMenu">
            <div class="pictCnt">
              <div :class="{thePict: 1, hasPhoto: $session.get('avatar')}"
                :style="{'background-image': `url(${$session.get('avatar')})`}">
                <span>{{$session.get('name').substr(0,2)}}</span>
              </div>
            </div>
            <h4>{{$session.get('name')}}</h4>
            <h5>{{$session.get('email')}}</h5>
            <!-- <div class="divider"></div> -->
            <!-- <li v-on:click="accountSetting">Pengaturan Akun</li> -->
            <!-- <li v-on:click="pesanKreasi">Pesan dan Kreasi Saya</li> -->
            <div class="divider"></div>
            <li v-on:click.stop="signOut">Keluar</li>
          </div>
        </div>
      </div>
      <div class="menuOverlay" v-on:click="toggleMenu"></div>
      <div class="menuToggle" v-on:click="toggleMenu"></div>
      <div class="loginForMobile">
        <div class="loginBtn" v-on:click="$emit('login')" v-if="!$session.get('jwt')">Masuk</div>
          <div class="userPict" v-else v-on:click.stop="doNothing">
            <div :class="{headerPict: 1, hasPhoto: $session.get('avatar')}"
              :style="{'background-image': `url(${$session.get('avatar')})`}"
              v-on:click.stop="showMenu = true">
              <span>{{$session.get('name').substr(0,2)}}</span>
            </div>
            <div class="userMenuOverlay" v-if="showMenu" v-on:click.stop="showMenu = false"></div>
            <div class="userMenu" v-if="showMenu">
              <div class="pictAndName">
                <div class="pictCnt">
                  <div :class="{thePict: 1, hasPhoto: $session.get('avatar')}"
                    :style="{'background-image': `url(${$session.get('avatar')})`}">
                    <span>{{$session.get('name').substr(0,2)}}</span>
                  </div>
                </div>
                <h4>{{$session.get('name')}}</h4>
                <h5>{{$session.get('email')}}</h5>
              </div>
              <!-- <div class="divider"></div> -->
              <!-- <li v-on:click="accountSetting">Pengaturan Akun</li> -->
              <!-- <li v-on:click="pesanKreasi">Pesan dan Kreasi Saya</li> -->
              <div class="divider"></div>
              <li v-on:click.stop="signOut">Keluar</li>
            </div>
          </div>
        </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      menuOpen: false,
      menuAnimate: false,
      showSubmenu: false,
      showSubmenu2: false,
      showMenu: false,
    };
  },
  props: ['scrolled'],
  computed: {
    ...mapState([
      'menuActive',
    ]),
  },
  methods: {
    doNothing() {},
    accountSetting() {},
    pesanKreasi() {},
    signOut() {
      this.$session.destroy();
      window.location.reload();
    },
    toggleMenu() {
      if (this.menuOpen) {
        this.menuAnimate = false;
        setTimeout(() => {
          this.menuOpen = false;
        }, 300);
      } else {
        this.menuOpen = true;
        setTimeout(() => {
          this.menuAnimate = true;
        }, 10);
      }
    },
  },
  watch: {
    $route() {
      this.menuAnimate = false;
      setTimeout(() => {
        this.menuOpen = false;
      }, 300);
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
header{
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 2000;
  .headerBg{
    background-color: #fff;
    position: absolute; right: 0; left: 0; top: 0; height: 0px;
    transition: all .3s ease;
    border-bottom: #eee 1px solid;
  }
  &.scrolled{
    .headerBg{
      height: 80px;
      @media (max-width: 768px) {
        height: 64px;
      }
    }
    .logoLink{
      height: 80px; width: 80px;
      .logo{
        height: 80px; width: 80px;
        top: 0px; left: 15px;
        opacity: 1;
        &.white{
          opacity: 0;
        }
      }
      @media (max-width: 768px) {
        width: 64px; height: 64px;
        .logo{
          width: 64px; height: 64px;
          left: 0;
        }
      }
    }
    .menuToggle{
      background-image: url(../assets/menu.png);
    }
    .menu{
      .menuItem{
        color: #444;
        &:hover{
          color: #444;
          border-color: #ccc;
        }
      }
    }
  }
  &.menuOpen{
    z-index: 9991;
    .menu{
      @media (max-width: 768px) {
        display: block;
      }
    }
    .menuOverlay{
      display: block;
    }
  }
  &.menuAnimate{
    .menu{
      right: 0;
      opacity: 1;
    }
    .menuOverlay{
      opacity: .5;
    }
  }
  .container{
    position: relative;
    max-width: 1600px;
    margin: 0 auto;
  }
  .logoLink{
    width: 110px;
    height: 110px;
    display: block;
    margin-left: 14px;
    position: relative;
    .logo{
      width: 110px;
      height: 110px;
      background-image: url(../assets/logo.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .4s ease;
      position: absolute;
      left: 0; top: -10px;
      opacity: 0;
      &.white{
        background-image: url(../assets/logo-white.png);
        opacity: 1;
      }
    }
    @media (max-width: 1100px) {
      margin-left: 10px;
    }
    @media (max-width: 768px) {
      margin-left: 4px;
      width: 96px; height: 96px;
      .logo{
        width: 96px; height: 96px;
      }
    }
  }
  .loginForMobile{
    display: none;
    position: absolute;
    right: 48px; top: 15px;
    @media (max-width: 768px) {
      .userMenu{
        padding-top: 10px;
        .pictAndName{
          position: relative;
          padding-left: 60px;
          h5, h4{
            text-align: left;
          }
          h4{
            font-size: 18px;
          }
          h5{
            margin-top: -3px;
          }
          .pictCnt{
            .thePict{
              position: absolute;
              left: 20px; top: 6px;
              width: 46px; height: 46px;
              font-size: 20px;
            }
          }
        }
      }
      display: block;
      .userPict{
        display: block;
        .headerPict{
          font-size: 13px;
        }
      }
      .loginBtn{
        display: block;
        margin-top: -3px;
        margin-right: 26px;
      }
    }
  }
  .userPict{
    position: relative;
    margin: 0 20px;
    @media (max-width: 760px) {
      display: none;
    }
    .headerPict{
      cursor: pointer;
      width: 40px; height: 40px;
      border-radius: 50%;
      font-size: 18px;
      font-weight: normal;
      text-transform: uppercase;
      background-color: #620509;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center;
      background-size: cover;
      &.hasPhoto{
        span{
          display: none;
        }
      }
      @media (max-width: 760px) {
        height: 34px; width: 34px;
        font-size: 16px;
      }
    }
    .userMenuOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
    }
    .userMenu{
      position: absolute;
      background-color: #fff;
      padding: 20px 0 10px;
      color: #444;
      right: -5px; top: 100%;
      box-shadow: 2px 2px 5px rgba(0,0,0,.4);
      width: 320px;
      box-sizing: border-box;
      text-transform: none;
      margin-top: 6px;
      border-radius: 10px;
      .pictCnt{
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        .thePict{
          width: 80px; height: 80px;
          border-radius: 50%;
          color: #fff;
          background-color: #620509;
          font-size: 38px;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          justify-content: center;
          background-size: cover;
          background-position: center;
          &.hasPhoto{
            span{
              display: none;
            }
          }
        }
      }
      h4, h5{
        margin: 0 20px;
        font-size: 20px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      h5{
        font-size: 15px;
        font-weight: normal;
        color: #767676;
        margin-bottom: 20px;
      }
      li{
        list-style: none;
        padding: 10px 30px;
        cursor: pointer;
        .bl{
          float: right;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        @media (max-width: 760px) {
          font-weight: 500;
          font-size: 18px;
          padding: 10px 20px;
        }
      }
      .divider{
        border-bottom: #eee 1px solid;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      @media (max-width: 760px) {
        right: -54px;
        margin-top: 0;
        // position: fixed;
        // left: 0; right: 0; top: 51px; bottom: 0;
        // border-radius: 0;
        // box-shadow: none;
        // border-top: #eee 1px solid;
        // width: auto; margin: 0;
      }
    }
  }
  .loginBtn{
    background-color: #31c1f4;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    margin-left: 20px;
    margin-right: 20px;
    color: #fff;
    font-weight: 700;
    border-radius: 3px;
    box-shadow: 2px 2px 2px rgba(0,0,0,.1);
    cursor: pointer;
    transition: all .3s ease;
    @media (max-width: 760px) {
      display: none;
    }
    &:hover{
      background-color: #1eb0e4;
    }
  }
  .menuToggle{
    display: none;
    @media (max-width: 768px) {
      transition: all .2s ease;
      display: block;
      width: 50px; height: 50px;
      border-radius: 50%;
      position: absolute;
      right: 14px; top: 7px;
      z-index: 3;
      background-image: url(../assets/menu-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 1;
    }
  }
  .menuOverlay{
    display: none;
    @media(max-width: 768px){
      display: block;
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: 0;
      display: none;
      transition: all .3s ease;
    }
  }
  .menu{
    position: absolute;
    top: 20px; bottom: 7px; right: 14px;
    display: flex;
    transition: all .3s ease;
    .menuItem{
      display: block;
      height: 36px;
      line-height: 36px;
      padding: 0 14px;
      margin: 0 2px;
      text-decoration: none;
      color: #fff;
      font-size: 16px;
      transition: all .3s ease;
      border-bottom: transparent 2px solid;
      cursor: pointer;
      position: relative;
      @media (max-width: 768px) {
        border: none;
      }
      &:hover{
        color: #fff;
        border-color: #fff;
      }
      &.active{
        border-color: #31c1f4;
      }
      @media (max-width: 768px) {
        color: #444 !important;
        height: auto;
        border-left: transparent 2px solid;
        border-bottom: none;
        margin-bottom: 10px !important;
        &.hasSubmenu{
          &:before{
            content: "";
            position: absolute;
            right: 8px; top: 0;
            width: 20px; height: 38px;
            background-image: url(../assets/arrow-down-bold.png);
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
            opacity: .5;
          }
        }
      }
      .submenuOverlay{
        background-color: rgba(0,0,0,.3);
        position: fixed;
        z-index: 7;
        left: 0; top: 0; right: 0; bottom: 0;
        @media (max-width: 768px) {
          display: none !important;
        }
      }
      .submenu{
        position: absolute;
        z-index: 9;
        background-color: #fff;
        padding: 10px 0;
        left: -6px; top: 100%;
        margin-top: -2px;
        border-radius: 5px;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        overflow: hidden;
        @media (max-width: 768px) {
          display: block;
          position: static;
          box-shadow: none;
          margin: 6px 0 0;
          background-color: rgba(0, 0, 0, .1);
        }
        a{
          display: block;
          text-decoration: none;
          color: #444;
          padding: 4px 20px;
          white-space: nowrap;
          font-size: 15px;
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
    .closeMenu{
      display: none;
    }
    .menuHome{
      display: none;
    }
    @media (max-width: 768px) {
      position: fixed;
      top: 0; right: -300px; bottom: 0;
      opacity: 0;
      background-color: #fff;
      display: none;
      transition: all .3s ease;
      padding: 40px 20px 0;
      min-width: 300px;
      z-index: 12;
      .menuItem{
        margin-bottom: 20px;
      }
      .menuHome{
        display: block;
      }
      .closeMenu{
        display: block;
        width: 50px; height: 50px;
        border-radius: 50%;
        position: absolute;
        right: 14px; top: 7px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .8;
      }
    }
  }
  &.dark{
    .menuToggle{
      background-image: url(../assets/menu-white.png);
    }
    .headerBg{
      background-color: #222;
      border-color: #222;
    }
    .menu{
      .menuItem{
        color: #fff;
        &:hover{
          color: #fff;
        }
      }
    }
  }
}
</style>
